<div class="row">
    <div class="sub-heading px-4 py-2 mb-3">
        <h2><span class="text-primary">Hi {{userName | titlecase}}</span>, What can I help you with today?
        </h2>
    </div>

    <div class="offset-lg-1 col-lg-10 col-12 p-lg-0 welcome-content">
        <div class="page-detail">

          
            <div class="prompts-container row row-cols-1 row-cols-md-3 g-4">
                <div class="col-6  col-md-6 col-lg-4 col-xl-4" *ngFor="let list of promptList, let i = index"
                    (click)="sentToInput(list)">
                    <div class="card shadow-sm rounded-3 border-1 border-light   text-left" role="button"
                        tabindex="0">

                        <div class="card-body pl-2 pr-2 pt-1 pb-1">
                           

                            <div class="d-flex">
                                <div class="flex-shrink-0 d-flex">
                                    <span *ngIf="list?.icon"  class="icon">
                                        <app-svg-icon [iconName]="list?.icon"></app-svg-icon>
                                        <!-- <img [src]="getIconPath(list.icon)" [alt]="list?.title" />  -->
                                    </span>
                                </div>
                                <div class="flex-grow-1 ms-2">
                                    <h6 class="prompt-title" >
                                        {{ list?.title }}
                                        <span *ngIf="list?.isBeta">
                                            <sup class="text-beta">Beta</sup>
                                        </span>
                                    </h6>
                                </div>
                                <span *ngIf="list?.isPlugin"  ngbTooltip="Plugin">
                                    <!-- <img src="/assets/images/icons/plugin-icon.svg" alt="Plugin" loading="lazy" /> -->
                                    <app-svg-icon [iconName]="'plugin-icon.svg'"></app-svg-icon>
                                  </span>
                            </div>

                            <p class="prompt-text text-secondary">{{ list?.prompt | capitalize | truncateText:120:true
                                }}</p>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>
</div>